import { handleActions } from "redux-actions";
import { createReducer } from "../baseReducer/baseReducer";
import { api } from "api";
import { NotificationManager } from "react-notifications";
import moment from "moment";

// ------------------------------------
// Constants
// ------------------------------------
const FILTER_BY_START_DATE_REGION_REPORT = "FILTER_BY_START_DATE_REGION_REPORT";
const FILTER_BY_END_DATE_REGION_REPORT = "FILTER_BY_END_DATE_REGION_REPORT";
const FILTER_BY_REGION_REGION_REPORT = "FILTER_BY_REGION_REGION_REPORT";
const SET_EXCEL_LOADING_REGION = "SET_EXCEL_LOADING_REGION";
const SET_EXCEL_PROGRESS_REGION = "SET_EXCEL_PROGRESS_REGION";
const SET_SHOW_PATIENTS_REGION_REPORT = "SET_SHOW_PATIENTS_REGION_REPORT";
const SET_EXCEL_LOADING_REGION_V2 = "SET_EXCEL_LOADING_REGION_V2";
export const baseReducer = createReducer(
    "region_report",
    "reports/emergency_report_detail", // Use the detailed listing endpoint for the regional view
    "RegionReport"
);

// ------------------------------------
// Actions
// ------------------------------------

const setFilterByStartDate = (start_date) => ({
    type: FILTER_BY_START_DATE_REGION_REPORT,
    start_date,
});

const setFilterByEndDate = (end_date) => ({
    type: FILTER_BY_END_DATE_REGION_REPORT,
    end_date,
});

const setFilterByRegion = (region) => ({
    type: FILTER_BY_REGION_REGION_REPORT,
    region,
});

const setShowPatients = (show_patients) => ({
    type: SET_SHOW_PATIENTS_REGION_REPORT,
    show_patients,
});

const setExcelLoading = (payload) => ({
    type: SET_EXCEL_LOADING_REGION,
    payload,
});

const setExcelProgress = (payload) => ({
    type: SET_EXCEL_PROGRESS_REGION,
    payload,
});

const descargarExcel = () => (dispatch, getStore) => {
    // ... existing descargarExcel logic ...
    const resource = getStore()["region_report"];

    // filter start date
    const start_date = resource.start_date
        ? moment(resource.start_date).format("YYYY-MM-DD")
        : "";
    // filter end date
    const end_date = resource.end_date
        ? moment(resource.end_date).format("YYYY-MM-DD")
        : "";

    // filter region
    const region_type = resource.region ? resource.region : "";

    const show_patients = resource.show_patients !== false;

    const params = {
        start_date,
        end_date,
        region_type,
        show_patients
    };

    if (start_date && end_date) {
        if (end_date < start_date)
            return NotificationManager.error(
                "La fecha inicial no puede ser mayor a la fecha final",
                "ERROR",
                0
            );
    }

    dispatch(setExcelLoading(true));
    dispatch(setExcelProgress(0));

    api.getWithProgress("reports/download_excel_region", params, (percent) => {
        dispatch(setExcelProgress(percent));
    })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Reporte_Por_Region.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch(() => {
            NotificationManager.error('Error al descargar', 'ERROR');
        }).finally(() => {
            dispatch(setExcelLoading(false));
            dispatch(setExcelProgress(0));
        });
};

const descargarExcelV2 = () => (dispatch, getStore) => {
    const resource = getStore()["region_report"];
    const start_date = resource.start_date ? moment(resource.start_date).format("YYYY-MM-DD") : "";
    const end_date = resource.end_date ? moment(resource.end_date).format("YYYY-MM-DD") : "";
    const region_type = resource.region ? resource.region : "";
    const show_patients = resource.show_patients !== false;

    if (start_date && end_date && end_date < start_date)
        return NotificationManager.error("La fecha inicial no puede ser mayor a la fecha final", "ERROR", 0);

    dispatch({ type: SET_EXCEL_LOADING_REGION_V2, payload: true });

    api.getWithProgress("reports/download_excel_region_v2", { start_date, end_date, region_type, show_patients }, () => { })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Reporte_Por_Region_VersionB.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch(() => {
            NotificationManager.error('Error al descargar', 'ERROR');
        }).finally(() => {
            dispatch({ type: SET_EXCEL_LOADING_REGION_V2, payload: false });
        });
};

const listarReport =
    (page = 1) =>
        (dispatch, getStore) => {
            const resource = getStore()["region_report"];
            const params = { page };

            // filter start date
            const start_date = resource.start_date
                ? moment(resource.start_date).format("YYYY-MM-DD")
                : "";
            params.start_date = start_date;
            // filter end date
            const end_date = resource.end_date
                ? moment(resource.end_date).format("YYYY-MM-DD")
                : "";
            params.end_date = end_date;

            if (start_date && end_date)
                if (end_date < start_date)
                    return NotificationManager.error(
                        "La fecha inicial no puede ser mayor a la fecha final",
                        "ERROR",
                        0
                    );

            // Filter by region
            const region_ = resource.region;
            params.region_type = region_;

            dispatch(baseReducer.actions.setLoader(true));
            api.get("reports/region_report_data", params)
                .then((response) => {
                    let dataToSet = response;
                    if (response && response.results) {
                        dataToSet = response.results;
                        dataToSet.grand_total_unique = response.grand_total_unique;
                    }
                    dispatch(baseReducer.actions.setData(dataToSet));
                    dispatch(baseReducer.actions.setPage(page));
                })
                .catch(() => { })
                .finally(() => {
                    dispatch(baseReducer.actions.setLoader(false));
                });
        };

const setStartDate = (value) => (dispatch, getStore) => {
    dispatch(setFilterByStartDate(value));
    // The list will trigger fetching when the endDate is successfully captured, preserving atomic date range updates.
};

const setEndDate = (value) => (dispatch, getStore) => {
    dispatch(setFilterByEndDate(value));
    const resource = getStore()["region_report"];
    if (resource.start_date && value) {
        dispatch(listarReport());
    } else if (!resource.start_date && !value) {
        dispatch(listarReport());
    }
};

const setRegion = (value) => (dispatch, getStore) => {
    dispatch(setFilterByRegion(value));
    dispatch(listarReport());
};

export const actions = {
    listarReport,
    setStartDate,
    setEndDate,
    setRegion,
    descargarExcel,
    descargarExcelV2,
    setShowPatients,
    ...baseReducer.actions,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    ...baseReducer.reducers,
    [FILTER_BY_START_DATE_REGION_REPORT]: (state, { start_date }) => {
        return {
            ...state,
            start_date,
        };
    },
    [FILTER_BY_END_DATE_REGION_REPORT]: (state, { end_date }) => {
        return {
            ...state,
            end_date,
        };
    },
    [FILTER_BY_REGION_REGION_REPORT]: (state, { region }) => {
        return {
            ...state,
            region,
        };
    },
    [SET_SHOW_PATIENTS_REGION_REPORT]: (state, { show_patients }) => {
        return {
            ...state,
            show_patients,
        };
    },
    [SET_EXCEL_LOADING_REGION]: (state, { payload }) => ({ ...state, excelLoading: payload }),
    [SET_EXCEL_PROGRESS_REGION]: (state, { payload }) => ({ ...state, excelProgress: payload }),
    [SET_EXCEL_LOADING_REGION_V2]: (state, { payload }) => ({ ...state, excelLoadingV2: payload }),
};

export const initialState = {
    start_date: "",
    end_date: "",
    region: "",
    show_patients: true,
    excelLoading: false,
    excelProgress: 0,
    excelLoadingV2: false,
};

export default handleActions(reducers, initialState);
